import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '@geekbears/ngx-gb-ui-kit';

@Component({
  selector: 'app-auth-modals',
  templateUrl: './account-setup-complete.modal.html',
  styleUrls: ['./account-setup-complete.modal.scss'],
})
export class AccountSetupCompleteModal
  extends ModalComponent
  implements OnInit
{
  constructor(private dialogRef: MatDialogRef<AccountSetupCompleteModal>) {
    super();
  }

  navigateLogin() {
    this.closeModal();
  }

  ngOnInit(): void {}

  closeModal() {
    this.dialogRef.close();
  }
}
